'use client'

import * as React from 'react';
import './cardgalery.css';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';



// Reusable WordCard component

// passes bgposition prop in as a class and this can be used to control the background position 
// of the card images by use=ing that class to apply csss
const WordCard = ({ title, definition, example, image , bgposition }) => {
  return (
    <Card  className={bgposition} sx={{ minWidth: 275,
        boxShadow: 'lg',
        height: '300px',
            width: '100%',
            maxWidth: '100%',
            // to make the demo resizeable
            overflow: 'hidden',
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            // backgroundPosition: "center",
            
    
    }}>
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        
        <Typography sx={{ textAlign: 'center' , color : 'white' }} variant="h5" component="div">
          {title}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', flexGrow: 1 }}>
        <Typography sx={{ textAlign: 'center' , color : 'white' }} variant="body1">
          {definition}
          <br />
          {example}
        </Typography>
        </Box>

      </CardContent>
      
    </Card>
  );
};

export default WordCard;